(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-recommendations"] && !Shopify.designMode) return;
  try {
    /* Sincroniza o preço com o tamanho escolhido (delegado — pega cards que entram
     pelo morph também). */
  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target || !target.matches || !target.matches('.cart-upsell__select')) return;
    const card = target.closest('.cart-upsell__card');
    const price = card && card.querySelector('[data-decant-price]');
    const option = target.options[target.selectedIndex];
    if (price && option && option.dataset.price) {
      price.textContent = option.dataset.price;
    }
  });

  /* Setas do carrossel: rolam um card e desabilitam nas pontas (delegado +
     scroll em fase de captura, pra pegar carrosséis que entram pelo morph). */
  function cartUpsellUpdateArrows(list) {
    const root = list.closest('.cart-upsell');
    if (!root) return;
    const prev = root.querySelector('.cart-upsell__arrow--prev');
    const next = root.querySelector('.cart-upsell__arrow--next');
    if (prev) prev.disabled = list.scrollLeft <= 1;
    if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
  }

  document.addEventListener('click', function (event) {
    const arrow = event.target.closest && event.target.closest('.cart-upsell__arrow');
    if (!arrow) return;
    const root = arrow.closest('.cart-upsell');
    const list = root && root.querySelector('.cart-upsell__list--carousel');
    if (!list) return;
    const card = list.querySelector('.cart-upsell__card');
    const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : list.clientWidth;
    const dir = arrow.classList.contains('cart-upsell__arrow--next') ? 1 : -1;
    list.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      const list = event.target;
      if (list && list.classList && list.classList.contains('cart-upsell__list--carousel')) {
        cartUpsellUpdateArrows(list);
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    const bump = (input) => {
      input.classList.remove('cart-qty-bump');
      void input.offsetWidth;
      input.classList.add('cart-qty-bump');
    };

    const observe = () => {
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer || drawer.dataset.qtyBumpBound) return;
      drawer.dataset.qtyBumpBound = 'true';

      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-cart-quantity' &&
            mutation.target instanceof HTMLInputElement
          ) {
            bump(mutation.target);
          }
        }
      }).observe(drawer, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-cart-quantity'],
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
